import axios from "axios"
import Config from '@/config/config'

axios.defaults.baseURL = Config.APIURL;
import Login from '@/components/api/auth';
// const _axiosErrorHandler = async (err: any, options: axiosOptionsType = {}) => {
//
// }
function _makeAxiosParams(option) {
  console.log(option);
  // for
}
// const _makeAxiosParams = function (options) {
//   console.log(options);
// 	// let params: any = {};
// 	// if (queryObj) {
// 	// 	params.params = queryObj;
// 	// }
// 	// if (options.idToken) {
// 	// 	params.headers = { Authorization: options.idToken };
// 	// } else {
// 	// 	params.headers = { Authorization: userModule.ID_TOKEN };
// 	// }
// 	return params;
// };
async function _axiosErrorHandler(err) {
  // console.log(err);
  // console.log(err.response);
  // console.log(err.response.data);
  // console.log(err.response.data.errorCode);
  if(err.response.data.errorCode == 'expired_token') {
    console.log('token error');
    const refreshRes = Login.refresh();
    if(refreshRes) {
      console.log('refreshToken更新成功');
      return true;
    } else {
      console.log('refreshToken更新エラー');
      return false;
    }
  } else {
    return false;
  }
}

async function axiosGet(url, options) {
  try {
    // console.log('axiosGet check localStorage AccessToken');
    // console.log(localStorage.getItem('accessToken'));
    const res = await axios.get(url, {
      headers: { 'Authorization': 'Bearer '+ localStorage.getItem('accessToken') },
      params: options
    });
    if (res.status === 200) {
      return res.data;
    } else {
      console.log("ステータスコード200以外が返りました。");
      return res.data;
    }
  } catch (e) {
    console.log(e);
    console.log(e.response.data);
    console.log(e.response.status);
    console.log(e.response.headers);
    let refreshRes = await _axiosErrorHandler(e);
    if(refreshRes) {
      return await axiosGet(url, options);
    } else {
      return false;
    }
  }
}

async function axiosPost(url, options) {
  try {
    const res = await axios.post(url, options,{
      headers: {
        'Content-type': 'application/json',
        'Authorization': 'Bearer '+ localStorage.getItem('accessToken')
      },
    })
    if (res.status === 200) {
      // console.log(res.status);
      return res.data;
    } else {
      console.log("ステータスコード200以外が返りました。");
      return res.data;
    }
  } catch (e) {
    console.log(e.response.data);
    console.log(e.response.status);
    console.log(e.response.headers);
    let refreshRes = await _axiosErrorHandler(e);
    if(refreshRes) {
      return await axiosPost(url, options);
    } else {
      return e.response.data;
    }
  }
}

async function axiosPut(url, options) {
  try {
    const res = await axios.put(url, options,{
      headers: {
        'Content-type': 'application/json',
        'Authorization': 'Bearer '+ localStorage.getItem('accessToken')
      },
    })
    if (res.status === 200) {
      // console.log(res.status);
      return res.data;
    } else {
      console.log("ステータスコード200以外が返りました。");
      return res.data;
    }
  } catch (e) {
    console.log(e.response.data);
    console.log(e.response.status);
    console.log(e.response.headers);
    let refreshRes = await _axiosErrorHandler(e);
    if(refreshRes) {
      return await axiosPut(url, options);
    } else {
      return false;
    }
  }
}

async function axiosLogin(url, options) {
  try {
    const res = await axios.post(url, options,{
      headers: {
        'Content-type': 'application/json',
      },
    });

    if (res.status === 200) {
      // console.log(res.status);
      // console.log(res.data);
      return res.data;
    } else {
      console.log("ステータスコード200以外が返りました。");
      return res.data;
    }
  } catch (e) {
    // console.log(typeof(e));
    // for(let key of Object.keys(e)) {
    //   console.log(key);
    //   console.log(e[key]);
    // }
    // console.log(e.response.data.errorCode);
    // console.log(e.response.data);
    // console.log(e.response.status);
    // console.log(e.response.headers);
  }
}

export default {
  axiosPost,
  axiosGet,
  axiosPut,
  axiosLogin
}



// WEBPACK FOOTER //
// ./src/components/api/axios.js